import axios from 'axios';

const { SECURITY_LOGGING_ENABLED } = process.env;

export default {
  isLoggingEnabled: SECURITY_LOGGING_ENABLED,
  authentication: {
    authenticationRoutePath: '/',
    defaultRedirectRoutePath: '/search',
    refresh: {
      activeThresholdSeconds: 60, // 60 seconds
    },
    session: {
      callbackUrlSessionItem: 'callbackUrl',
      autoLogoutTimerSeconds: 10, // 300, // 5 minutes
      autoLogout: false, // todo: Not used, currently but we should implement a feature that checks on an interval to see if user's session is over and redirect to login.
    },
    whitelist: { // Bypass authentication
      apis: [
        `${axios.defaults.baseURL}exampletest`,
      ], // Don't authenticate for these api's
      routes: [
        'exampletest',
      ], // Don't authenticate any api calls from these routes using route name not path
    },
  },
};



// WEBPACK FOOTER //
// ./src/security/options.js